//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Checkbox, Select, Typography } from '@backmarket/design-system'
import isEmpty from 'lodash.isempty'
import { mapGetters } from 'vuex'

import { trackClick } from '@tracking/events'

import SearchParams from '../../../utils/SearchParams'

import translations from './CarrierFilters.translations'

export default {
  components: {
    Checkbox,
    Select,
    Typography,
  },
  computed: {
    translations: () => translations,
    ...mapGetters({
      carriers: 'landingSearch/carriersFilter',
      simlock: 'landingSearch/simlockFilter',
      filterWhitelist: 'landingSearch/filterWhitelist',
    }),
    filters() {
      const context = {
        source: this.$route.name,
        slug: this.$route.params.category,
      }

      const searchParams = new SearchParams({
        query: this.$route.query,
        hash: this.$route.hash,
        context,
        paramsWhitelist: this.filterWhitelist,
      })

      return searchParams.whitelistedParameters
    },

    selectedSimlockState: {
      get() {
        return this.filters.sim_lock_state?.[0] ?? ''
      },
      set(value) {
        this.$emit('filter', {
          [this.simlock.facetName]: value,
        })
      },
    },
    selectedCarriers: {
      get() {
        return this.filters.compatible_carriers_facet || []
      },
      set(value) {
        this.$emit('filter', {
          [this.carriers.facetName]: value,
        })
      },
    },
    hasFilters() {
      return !isEmpty(this.carriers) && !isEmpty(this.simlock)
    },
  },
  methods: {
    trackSimLock(selectedSimLock) {
      trackClick({
        zone: 'product list > top filter',
        name: 'sim_lock_state',
        value: selectedSimLock.toLowerCase().replaceAll(' ', '_'),
      })
    },
    trackCarrier(selectedCarrier) {
      const filters = this.filters.compatible_carriers_facet || []
      const isSelectedCarrierInFilters = filters.includes(
        selectedCarrier.facetValue,
      )
      const hasNoMoreFilters =
        isSelectedCarrierInFilters && filters.length === 1
      const newFilters = isSelectedCarrierInFilters
        ? filters.filter((filter) => filter !== selectedCarrier.facetValue)
        : [...filters, selectedCarrier.facetValue]

      if (!hasNoMoreFilters) {
        trackClick({
          zone: 'product list > top filter',
          name: 'compatible_carriers_facet',
          value: newFilters,
        })
      }
    },
  },
}
